import { constants } from "../constants";

export const DEFAULT_STATE = {
  monerisResp: {}
};

const var1 = (state = DEFAULT_STATE, { type, payload } = {}) => {
  switch (type) {
    case constants.SET_MONERIS_RESP:
      return { ...state, monerisResp: payload.monerisResp };
    case constants.CLEAR_MONERIS_RESP:
      return DEFAULT_STATE;
    default:
      return state;
  }
};

export default var1;
